import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCrown, FaTrophy, FaClock, FaUserFriends } from "react-icons/fa";

const ChallengeLog = () => {
  const [challenges, setChallenges] = useState([]);
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_APP_BASE_URL;
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${baseUrl}/play/challenges/user/${userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Received challenges:", data.challenges);
        setChallenges(data.challenges || []);
        setStatus("complete");
      } catch (error) {
        console.error("Error fetching challenges:", error);
        setError(error.message);
        setStatus("error");
      }
    };
    fetchChallenges();
  }, [baseUrl, userId]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (status === "loading") {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl text-gray-600">Loading challenges...</div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl text-red-500">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          Challenge History
        </h1>

        <div className="grid gap-6">
          {challenges.map((challenge) => (
            <div
              key={challenge.id}
              className="bg-white rounded-2xl shadow-lg p-6"
            >
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                {/* Challenge Info */}
                <div className="flex-grow">
                  <div className="flex items-center gap-3 mb-3">
                    <h2 className="text-xl font-semibold text-gray-800">
                      {challenge.subject} - {challenge.topic}
                    </h2>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${
                        challenge.status === "completed"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {challenge.status}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    {/* <div className="flex items-center gap-2 text-gray-600">
                      <FaUserFriends className="text-blue-500" />
                      <span>{challenge.mode}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600">
                      <FaTrophy className="text-yellow-500" />
                      <span>Level: {challenge.level}</span>
                    </div> */}
                    <div className="flex items-center gap-2 text-gray-600">
                      <FaClock className="text-gray-500" />
                      <span>{formatDate(challenge.timestamp)}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600">
                      <span>Questions: {challenge.numberOfQuestions}</span>
                    </div>
                  </div>

                  {/* Participants */}
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                        {(challenge.creatorHandle || "Guest")[0].toUpperCase()}
                      </div>
                      {challenge.status === "completed" &&
                        challenge.winner === challenge.creatorHandle && (
                          <FaCrown className="text-yellow-500" />
                        )}
                      <span className="text-gray-700">
                        {challenge.creatorHandle || "Guest"}
                      </span>
                    </div>
                    <span className="text-gray-400">vs</span>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center">
                        {(challenge.opponentHandle || "Guest")[0].toUpperCase()}
                      </div>
                      {challenge.status === "completed" &&
                        challenge.winner === challenge.opponentHandle && (
                          <FaCrown className="text-yellow-500" />
                        )}
                      <span className="text-gray-700">
                        {challenge.opponentHandle || "Guest"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Scores and Actions */}
                <div className="flex flex-col items-end gap-4">
                  {challenge.status === "completed" && (
                    <div className="text-right">
                      <div className="flex items-center gap-2 justify-end mb-2">
                        <FaCrown className="text-yellow-500" />
                        <span className="font-semibold text-gray-800">
                          Winner: {challenge.winner}
                        </span>
                      </div>
                      {/* <div className="text-sm text-gray-600">
                        {challenge.scores[challenge.creatorHandle]} - {challenge.scores[challenge.opponentHandle]}
                      </div> */}
                    </div>
                  )}

                  {challenge.status === "completed" && (
                    <button
                      onClick={() =>
                        navigate(`/practice/review?challengeId=${challenge.id}`)
                      }
                      className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg shadow transition"
                    >
                      Review Quiz
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {challenges.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No challenges found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChallengeLog;
